import React from 'react';
import PropTypes from 'prop-types';

import { useWindowSize } from '../../../hooks/useWindowSize';
import { BLOCK_TYPE } from '../../../constants/playbookBuilder';
import RichTextArea from '../../RichTextArea/RichTextArea';

RichTextBlock.propTypes = {
    blockData: PropTypes.shape({
        order: PropTypes.number,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        temporaryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        block_type: PropTypes.oneOf([BLOCK_TYPE.richtext]),
        properties: PropTypes.shape({
            content: PropTypes.string,
        }).isRequired,
    }),
    editMode: PropTypes.bool,
    handleDeleteBlock: PropTypes.func.isRequired,
    handleBlockPropertyChange: PropTypes.func.isRequired,
};

function RichTextBlock({
    blockData,
    editMode = false,
    handleDeleteBlock,
    handleBlockPropertyChange,
}) {
    const {
        properties: { content },
    } = blockData;

    const { width: screenWidth } = useWindowSize();
    const isMobile = screenWidth < 640;

    return (
        <div className={!editMode ? 'p-2.5' : ''}>
            {editMode && (
                <RichTextArea
                    value={content}
                    setValue={(value) => handleBlockPropertyChange('content', value)}
                    minHeight={isMobile ? 320 : 430}
                    autoExpand
                    placeholder="Enter content here"
                    withExtendedToolBar
                    handleDelete={handleDeleteBlock}
                />
            )}
            {!editMode && (
                <RichTextArea
                    value={content}
                    previewOnly
                    minHeight={20}
                    autoExpand
                    isBorderHidden
                />
            )}
        </div>
    );
}

export default RichTextBlock;
